/*@ngInject*/
const RuleActionGroupController = function ($element, $stateParams, $rootScope,
                                            umStudioConstant, configurationConstant, localization,
                                            ruleUtil, ruleMediator, ruleModel) {
    $element.addClass('ruleActionGroup');

    localization.getTranslations().then(function (translations) {

        this.doDeleteSubAction = function (subAction) {
            ruleMediator.deleteSubAction(this.ruleActionGroup, subAction);
            ruleModel.setUnsavedChanges($stateParams.ruleId, /*hasUnsavedChanges*/true);
            $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
        };

        this.addAction = function (action) {
            ruleMediator.addSubAction(this.ruleActionGroup, action);
            $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
            this.getActions();
        };

        this.getActionClassName = function (name) {
            return _.lowerFirst(_.replace(name, ' ', ''));
        };

        this.getActions = function () {
            ruleMediator.getRuleActions(this.ruleSetName.toLowerCase()).then(function (actions) {
                this.actions = actions;
            }.bind(this));
        };

        this.isDropup = function () {
            var dropmenu = $('.addActionDropdown');
            if (dropmenu.offset().top + dropmenu.outerHeight() + 300 /*height of the selectorMenu*/ > $(window).innerHeight() + $(window).scrollTop()) {
                return true;
            }
            return false;
        };

        this.getActions();

        $rootScope.$on(configurationConstant.event.RULE_MODEL_UPDATED, function (event, ruleId) {
            if (ruleId===parseInt($stateParams.ruleId)) {
                var rule = ruleModel.getRule(parseInt($stateParams.ruleId));
                this.ruleSetName = ruleUtil.getRuleSetName(rule);
                this.getActions();
            }
        }.bind(this));

    }.bind(this));
};

angular.module('umCore')
    .controller('ruleActionGroupController', RuleActionGroupController);


